export default {
    absoluteUrl: /(https?:\/\/[^\s]+)/g,
    url: /(?:www\.)?([a-zA-Z0-9_-]+)(?:\.[a-zA-Z]+)+/,
    youTubeUrl: /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/,
    passwordComplexity: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/,
    latitude: /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/,
    longitude: /^[-+]?((1[0-7]\d(\.\d+)?)|([1-9]?\d(\.\d+)?)|180(\.0+)?)$/,
    versioning: /^\d+\.\d+\.\d+$/,
    money: /^\d+(\.\d{1,2})?$/,
}